import { ChangeEvent, ReactElement } from 'react';
import { useField, useFormikContext } from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import { Box } from '@mui/material';

// Styles
import styles from './FormikRadioButton.module.scss';
import { visuallyHidden } from '@mui/utils';

// Types
interface IProps {
  formikKey: string;
  name: string;
  value: boolean;
}

export const FormikBooleanRadioField = ({ formikKey, value, ...rest }: IProps): ReactElement => {
  const [field] = useField(rest);
  const { setFieldValue, values } = useFormikContext();
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setFieldValue(formikKey, e.target.value === 'No');
  };
  const formikValue: boolean = get(values, formikKey);

  return (
    <Box sx={{ display: 'flex' }}>
      <label key={formikKey} className={classNames(styles.container)}>
        <input
          {...field}
          checked={value === formikValue}
          id={`${formikKey}.${field.name}`}
          name={formikKey}
          onChange={onChange}
          type="radio"
          value={field.name}
          title={field.name}
        />
        <span className={styles.checkmark} />
        <span style={visuallyHidden}>{field.name}</span>
      </label>
      <div className={styles.label}>{field.name}</div>
    </Box>
  );
};
